import React from 'react';
import { SecurityDashboard as SecurityDashboardComponent } from '@/components/security/SecurityDashboard';

export default function SecurityDashboard() {
  return (
    <div className="p-6">
      <SecurityDashboardComponent />
    </div>
  );
}